export abstract class SecretsStore {

  abstract set(key: string, value: string);

  abstract get(key: string): string;

  abstract remove(key: string);

  public getAndRemove(key: string): string {
    var val = this.get(key);
    this.remove(key);
    return val;
  }

  public setJson<T>(key: string, value: T) {
    this.set(key, JSON.stringify(value));
  }

  public getJson<T>(key: string): T {
    return JSON.parse(this.get(key));
  }
}
